<template>
  <v-card :loading="loading">
    <v-form>
      <v-container>
        <fieldset>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <label class="custom-label">Tutor</label>
              <v-autocomplete
                @change="tutorSelected"
                v-model="data.tutor_id"
                :error-messages="errors.tutor_id"
                :items="tutors"
                label="Choose Tutor"
                placeholder="Choose Tutor"
                :search-input.sync="tutor_search"
                persistent-hint
                solo
                single-line
              />
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Start Date</label>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="data.start_date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :readonly="
                      !(typeof data.tutor_id != 'undefined' && data.tutor_id != null)
                    "
                    v-model="formated_start_date"
                    :error-messages="errors.start_date"
                    label="Choose Date"
                    prepend-icon
                    v-bind="attrs"
                    v-on="on"
                    solo
                  ></v-text-field>
                </template>
                <v-date-picker
                :first-day-of-week="1"
                  :readonly="
                    !(typeof data.tutor_id != 'undefined' && data.tutor_id != null)
                  "
                  v-model="data.start_date"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(data.start_date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">End Date</label>
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="data.end_date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :readonly="
                      !(typeof data.tutor_id != 'undefined' && data.tutor_id != null)
                    "
                    v-model="formated_end_date"
                    label="Choose Date"
                    :error-messages="errors.end_date"
                    prepend-icon
                    v-bind="attrs"
                    v-on="on"
                    solo
                  ></v-text-field>
                </template>
                <v-date-picker
                :first-day-of-week="1"
                  :readonly="
                    !(typeof data.tutor_id != 'undefined' && data.tutor_id != null) &&
                    id != null
                  "
                  v-model="data.end_date"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu2.save(data.end_date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Total Hours</label>
              <v-text-field
                :readonly="
                  !(
                    typeof data.start_date != 'undefined' &&
                    data.start_date != null &&
                    typeof data.end_date != 'undefined' &&
                    data.end_date != null
                  )
                "
                @change="totalHoursChanged"
                type="number"
                v-model="data.total_hours"
                :error-messages="errors.total_hours"
                label="Total Hours"
                placeholder="Hours"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Amount</label>
              <v-text-field
                :readonly="
                  !(
                    typeof data.start_date != 'undefined' &&
                    data.start_date != null &&
                    typeof data.end_date != 'undefined' &&
                    data.end_date != null
                  ) && id != null
                "
                type="number"
                v-model="data.amount"
                :error-messages="errors.amount"
                label="Enter Amount"
                placeholder="Enter Amount"
                solo
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <label class="custom-label">Payment Date</label>
              <v-menu
                ref="menu_payment_date"
                v-model="menu_payment_date"
                :close-on-content-click="false"
                :return-value.sync="data.payment_date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :readonly="
                      !(typeof data.tutor_id != 'undefined' && data.tutor_id != null)
                    "
                    v-model="formated_payment_date"
                    :error-messages="errors.payment_date"
                    label="Select Payment Date"
                    prepend-icon
                    v-bind="attrs"
                    v-on="on"
                    solo
                  ></v-text-field>
                </template>
                <v-date-picker
                :first-day-of-week="1"
                  :readonly="
                    !(typeof data.tutor_id != 'undefined' && data.tutor_id != null)
                  "
                  v-model="data.payment_date"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu_payment_date = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu_payment_date.save(data.payment_date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <label class="custom-label">Payment Notes</label>
              <v-textarea
                solo
                v-model="data.notes"
                label="Type your notes here"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                :error-messages="errors.is_percent"
                label="Paid"
                v-model="data.is_paid"
              ></v-checkbox>
            </v-col>
          </v-row>
        </fieldset>

        <v-row>
          <v-col cols="12">
            <v-btn @click="save" :loading="loading" color="#6A158E" dark>Save</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import TutorSelectMixin from "../../mixins/tutorSelect";
import Form from "../../utils/form";
import moment from "moment";

export default {
  name: "TutorEarningForm",
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  mixins: [TutorSelectMixin],
  watch: {
    "data.payment_date": function (val, oldVal) {
      this.formated_payment_date = moment(val).format("DD-MM-YYYY");
    },
    "data.start_date": function (val, oldVal) {
      this.formated_start_date = moment(val).format("DD-MM-YYYY");
      this.calculateHoursAndAmount();
    },
    "data.end_date": function (val, oldVal) {
      this.formated_end_date = moment(val).format("DD-MM-YYYY");
      this.calculateHoursAndAmount();
    },
  },
  data() {
    return {
      menu: false,
      menu_payment_date: false,
      menu2: false,
      formated_payment_date: null,
      formated_start_date: null,
      formated_end_date: null,
      loading: true,
      data: {
        tutor_id: null,
        amount: 0,
        total_hours: 0,
        status: 1,
        notes: "",
        payment_date: null,
        start_date: null,
        end_date: null,
      },
      errors: {},
      selected_tutor: null,
      status: [
        {
          text: "Cleared",
          value: 2,
        },
        {
          text: "Pending",
          value: 1,
        },
      ],
    };
  },
  methods: {
    empty: function (value) {
      let response = true;
      if (
        value != null &&
        value !== "null" &&
        value !== "undefined" &&
        value !== undefined &&
        value !== ""
      ) {
        response = false;
      }
      return response;
    },
    calculateHoursAndAmount() {
      if (!this.empty(this.data.start_date) && !this.empty(this.data.end_date)) {
        let start_date = moment(this.data.start_date).format("YYYY-MM-DD HH:mm:ss");
        let end_date = moment(this.data.end_date).format("YYYY-MM-DD HH:mm:ss");
        let tutor_id = this.data.tutor_id;
        axios
          .post(apiRoutes.accounts.invoices.tutors.fetch, {
            start_date: start_date,
            end_date: end_date,
            tutor_id: tutor_id,
          })
          .then((response) => {
            if (this.id == null && response.data.status == "success") {
              this.data.total_hours = response.data.total_hours;
              this.data.amount = response.data.total_hours * response.data.rate_per_hour;
            }
          });
      }
    },
    totalHoursChanged() {
      if (
        typeof this.selected_tutor != "undefined" &&
        parseInt(this.data.total_hours) > 0
      ) {
        this.data.amount =
          parseFloat(this.selected_tutor.fare) * parseInt(this.data.total_hours);
      }
    },
    tutorSelected(event) {
      let tutor = this.tutors.find((item) => item.value === event);
      if (tutor) {
        this.selected_tutor = tutor;
        this.calculateHoursAndAmount();
      }
    },
    save() {
      if (this.id !== null) {
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      this.loading = true;
      let form = new Form({
        ...this.data,
      });
      form
        .post(apiRoutes.accounts.invoices.tutors.store)
        .then((response) => {
          this.$router.push({
            name: "Accounts",
            params: {
              tab: 3,
            },
          });
        })
        .catch((response) => {
          if (response.status === 400) {
            this.errors = response.data;
          }
          this.loading = false;
        });
    },
    update() {
      this.loading = true;
      let form = new Form({
        ...this.data,
      });
      form
        .post(apiRoutes.accounts.invoices.tutors.store, {
          id: this.id,
        })
        .then((response) => {
          this.$router.push({
            name: "Accounts",
            params: {
              tab: 3,
            },
          });
        })
        .catch((response) => {
          if (response.status === 400) {
            this.errors = response.data;
          }
          this.loading = false;
        });
    },
    formatDate(date) {
      return moment(date, "DD-MMM-YYYY", true).isValid()
        ? date
        : moment(date).format("DD-MM-YYYY");
    },
  },

  mounted() {
    this.loading = false;
    if (this.id != null) {
      axios
        .get(apiRoutes.accounts.invoices.tutors.getInvoice + "/" + this.id)
        .then((response) => {
          let is_paid = true;
          if (response.data.response.tutor_invoice_status === "pending") {
            is_paid = false;
          }
          this.data.tutor_id = response.data.response.tutor_id;
          
          
          this.data.payment_date = moment(response.data.response.created_at).format(
            "YYYY-MM-DD"
          );
          this.data.start_date = moment(response.data.response.start_date).format(
            "YYYY-MM-DD"
          );
          this.data.end_date = moment(response.data.response.end_date).format(
            "YYYY-MM-DD"
          );
          this.formated_start_date = this.formatDate(this.data.start_date);
          this.formated_payment_date = this.formatDate(this.data.payment_date);
          this.formated_end_date = this.formatDate(this.data.end_date);
          this.data.is_paid = is_paid;

          this.data.total_hours = response.data.response.total_hours;
          this.data.notes = response.data.response.notes;
          this.data.amount = response.data.response.amount;

          if (
            response.data.response.tutor != null &&
            typeof response.data.response.tutor != "undefined"
          ) {
            this.old_tutor = {
              value: response.data.response.tutor.tutor_id,
              text:
                response.data.response.tutor.tutor_lname +
                " " +
                response.data.response.tutor.tutor_fname,
              fare: response.data.response.tutor.tutor_per_hour_rate,
            };
            this.tutors = [this.old_tutor];
            this.selected_tutor = this.old_tutor;
          }
          this.data.tutor_invoice_id = response.data.response.tutor_invoice_id;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }
}
</style>
